import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useMenu } from '../../hooks/useMenu';

import OnBoardingContainer from '../../components/OnBoarding/OnBoardingContainer';
import { selectSettings } from '../../store/selectors/settingsSelectors';
import FundRetirementSourceForm from '../../components/Forms/FundRetirementSourceForm';

const FundRetirementSource = () => {
  const { activeMenu, activeItem } = useMenu();
  const { t } = useTranslation();
  const { BrokerName } = useSelector(selectSettings);
  // const { backStep } = useGtmStepTracker({
  //   currentPath: 'Financial Profile',
  //   previousPath: activeItem?.previousPath || '',
  // });

  return (
    <OnBoardingContainer
      activeMenu={activeMenu}
      activeItem={activeItem}
      previousPath={activeItem?.previousPath}
    >
      <Helmet>
        <title>
          {t('titleTagAmount', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <FundRetirementSourceForm nextPath={activeItem?.nextPath} />
    </OnBoardingContainer>
  );
};

export default FundRetirementSource;
